import { Component, Input, ViewContainerRef, ComponentRef, AfterViewInit, ViewChild,  Output, EventEmitter } from '@angular/core';
import { ActionRequestRead, ActionType } from '../julia-agent-openapi/models';
import { getPreviewComponent } from '../actions-previews-loaders';

@Component({
  selector: 'app-action-preview-modal',
  templateUrl: './action-preview-modal.component.html',
  styleUrls: ['./action-preview-modal.component.scss']
})
export class ActionPreviewModalComponent implements AfterViewInit {
  @ViewChild('previewContainer', { read: ViewContainerRef }) previewContainer!: ViewContainerRef;
  @Input() actionRequest!: ActionRequestRead;
  @Output() actionSelected = new EventEmitter<{ action: string }>();
  @Output() modalClosed = new EventEmitter<void>();
  
  previewComponentExists = false;
  private previewComponentRef: ComponentRef<any> | null = null;

  /** "Approve / Deny" is the wrong wording for a continuation prompt. */
  private get isContinuation(): boolean {
    return this.actionRequest?.action_type === ActionType.ContinueExecution;
  }

  get approveLabelKey(): string {
    return this.isContinuation
      ? 'julia.continuation.continue'
      : 'julia.action_preview.approve';
  }

  get denyLabelKey(): string {
    return this.isContinuation
      ? 'julia.continuation.stop'
      : 'julia.action_preview.deny';
  }

  constructor() {}

  ngAfterViewInit() {
    this.loadPreviewComponent();
  }

  private loadPreviewComponent() {
    console.log('Loading preview component for action type:', this.actionRequest.action_type);
    console.log('Preview data:', this.actionRequest.preview_data);
    console.log('Action data:', this.actionRequest.action_data);
    
    const ComponentClass = getPreviewComponent(this.actionRequest.action_type);
    
    if (ComponentClass && this.previewContainer) {
      this.previewComponentExists = true;
      this.previewComponentRef = this.previewContainer.createComponent(ComponentClass);
      
      // Pass data to the component
      this.previewComponentRef.instance.previewData = this.actionRequest.preview_data;
      this.previewComponentRef.instance.actionData = this.actionRequest.action_data;
      
      console.log('Preview component loaded successfully');
    } else {
      this.previewComponentExists = false;
      console.log('No preview component found for action type:', this.actionRequest.action_type);
    }
 
  }

  approve() {
    this.actionSelected.emit({ action: 'approve' });
  }

  deny() {
    this.actionSelected.emit({ action: 'deny' });
  }

  close() {
    this.modalClosed.emit();
  }

  ngOnDestroy() {
    if (this.previewComponentRef) {
      this.previewComponentRef.destroy();
    }
  }
}
